import { travelData } from "@escapio/portal/state/travelData";
import { formatISODate } from "@escapio/shared/l10n/date";
import { data } from "@escapio/shared/state/payload";
import { proxyTrack } from "@escapio/portal/tracker/FacebookProxy";

function track(event, customData) {
	console.info("Facebook tracker:", event, customData);
	if (typeof window.fbq === "function") {
		window.fbq("track", event, customData);
	} else {
		console.warn("Facebook tracker not preset", event, customData);
	}
}

function getTravelParams(city, region, country, hotelIds) {
	return {
		content_type: "hotel",
		content_ids: hotelIds,
		...(travelData.hasDates
			? {
					checkin_date: formatISODate(travelData.arrival),
					checkout_date: formatISODate(travelData.departure),
				}
			: {}),
		city: city,
		region: region,
		country: country,
		num_adults: travelData.allAdults,
		num_children: travelData.allChildren,
	};
}

function getTravelParamsWithPrice(hotel, price) {
	const params = getTravelParams(
		hotel.city_name,
		hotel.region_name,
		hotel.country_name,
		hotel.id,
	);

	if (price) {
		Object.assign(params, {
			value: price,
			currency: travelData.currency,
		});
	}

	return params;
}

export const trackViewContent = (hotel, totalRate) => {
	return track("ViewContent", getTravelParamsWithPrice(hotel, totalRate));
};

export const trackConversion = (hotel, totalRate) => {
	proxyTrack("InitiateCheckout", "hotel", hotel.id);
	return track("InitiateCheckout", getTravelParamsWithPrice(hotel, totalRate));
};

export function trackSearch(city, region, country, hotelIds) {
	const params = getTravelParams(city, region, country, hotelIds);
	track("Search", params);
}

export function trackLead() {
	track("Lead");
	proxyTrack("Lead");
}

export function trackAddToWishlist(hotelId, hotelName) {
	const params = {
		content_type: "hotel",
		content_ids: hotelId,
		content_name: hotelName,
	};

	if (data.prepositionedArticleTitle) {
		Object.assign(params, {
			content_category: data.prepositionedArticleTitle,
		});
	}
	track("AddToWishlist", params);
}
